import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { StorageService } from "../services/storage.service";
import { appRoute } from "src/app/app-route.constants";
import { canHandOffToReact, reactHomeUrl } from "../utils/home-route.util";

/**
 * Fallback routes (e.g. /marketing) are where SSO lands users who do NOT have
 * access to Rehab Connect, so there should never be an active session here.
 * If a session exists, the user must not remain on the fallback route — redirect
 * them into the app and let the existing guards/interceptor enforce validity.
 */
export const fallbackRouteGuard: CanActivateFn = () => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  const hasActiveSession =
    storageService.getUser() !== null && storageService.getAccessToken() !== null;

  if (hasActiveSession) {
    // Same rule as every other Home handoff: only enter React if React will
    // actually take the session, otherwise it bounces the user straight back.
    if (canHandOffToReact()) {
      window.location.replace(reactHomeUrl);
      return false;
    }
    return router.createUrlTree([`/${appRoute.home}`]);
  }

  return true;
};
